<template>
  <b-form class="" @submit.prevent="submit">
    <b-row>
      <b-col cols="6">
        <b-form-group id="input-group-name" label="Name" label-for="input-name">
          <b-form-input
            id="input-name"
            v-model.trim="form.name"
            v-validate="{ required: true, max: 100 }"
            type="text"
            placeholder="Name"
            size="lg"
            data-vv-name="name"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col cols="6">
        <b-form-group id="input-group-tag" label="Tag" label-for="input-tag">
          <multiselect
            v-model="form.tag"
            v-validate="{ required: true }"
            :options="tags"
            :taggable="true"
            :multiple="true" 
            placeholder="Select or enter a tag"
            tag-placeholder="Create new tag"
            open-direction="bottom"
            data-vv-name="tag"
            @tag="createTag"
          ></multiselect>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-group
          id="input-group-description"
          label="Description"
          label-for="input-description"
        >
          <b-form-textarea
            id="input-description"
            rows="8"
            v-model.trim="form.description"
            v-validate="{ required: true, max: 400 }"
            placeholder="Description"
            size="lg"
            data-vv-name="description"
          ></b-form-textarea>
        </b-form-group>
      </b-col>

      <b-col class="text-right" cols="12">
        <div class="form-footer">
            <b-btn variant="primary" size="lg" type="submit">
              <i class="fa fa-download" /> Save
            </b-btn>
        </div>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import _ from "lodash";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "ProjectForm",
  components: {
    Multiselect
  },
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      projects: state => state.project.projects,
      users: state => state.user.users
    }),
    tags() {
      return _.uniq(((this.projects.map(p => p.tag)).toString()).split(","));
    }
  },
  methods: {
    createTag(e) {
      this.form.tag.push(e);
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return;
        }

        this.$emit("callback");
      });
    }
  }
};
</script>
